import { Skeleton } from '@mui/material';

export const Placeholder = ({ size }: { size: number }) => {
  const loadingItems = Array.from({ length: size }, (_, index) => index);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
      {loadingItems.map((item) => (
        <div
          key={item}
          className="bg-white rounded-xl overflow-hidden border border-gray-100 p-3 sm:p-4 animate-pulse shadow-sm"
        >
          <div className="bg-gray-200 h-28 sm:h-32 w-full rounded-md mb-3" />
          <div className="flex flex-col gap-2 px-2 pb-2">
            <Skeleton width="80%" />
            <Skeleton width="100%" />
            <Skeleton width="40%" />
          </div>
        </div>
      ))}
    </div>
  );
};
